<template>
  <div class="container clearfix orderpad-popup">
    <div class="row">
      <div class="col-12">
        <span class="pull-right icon icon-close" @click="$emit('close')" style="cursor:pointer"></span>
        <b class="title">{{ title }}</b>
      </div>
    </div>
    <div class="row" v-if="!maxItemsReached">
      <drop-down-list
        @on-new-item="addItem($event)"></drop-down-list>
    </div>
    <div class="row" v-if="maxItemsReached">
      <div class="col-12">
        Maximum 5 items
      </div>
    </div>
    <div class="row selected-list" v-show="items.length">
      <div class="col-12">
        <span v-if="renderComponent">
          <item
            v-for="(item, index) in items"
            :key="index"
            :item="item"
            ref="items_refs"
            :enable_b2c="enable_b2c"
            :enable_b2b="enable_b2b"
            :netsuite_url="netsuite_url"
            :netsuite_app_url="netsuite_app_url"
            @on-delete="deleteItem(item)"
          ></item>
        </span>
      </div>
    </div>
    <div class="row" v-show="msg != ''">
      <div class="col-12">
          <span v-if="msg">{{ msg }}</span>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <button @click="addToCart" class="btn btn-primary btn-hover" v-bind:disabled="items.length == 0" style="width:100%">Add To Cart</button>
      </div>
    </div>
  </div>
</template>

<script>
import Item from "./item.vue";
import DropdownList from "./dropdown-list.vue";

export default {
  components: {
    'item' : Item,
    'drop-down-list' : DropdownList,
  },
  props: {
    title: String,
    enable_b2c: {},
    enable_b2b: {},
    netsuite_url: {},
    netsuite_app_url: {},
  },
  data() {
    return {
      items: [],
      maxItemsReached : false,
      renderComponent: true,
      msg : ""
    };
  },
  mounted() {

  },
  methods: {
    forceRerender() {
      this.renderComponent = false;
      this.$nextTick().then(() => {
        this.renderComponent = true;
      });
    },
    addItem(newItem) {
      this.msg = '';
      var not_found = 1;
      var tmpObj = {};

      for (var i = 0; i < this.items.length; i++) {
        if(this.items[i].stockCode == newItem.stockCode)
          {
            tmpObj = this.items[i];
            tmpObj.qty = tmpObj.qty + 1;
            this.$set(this.items, i, tmpObj);
            this.forceRerender();
            not_found = 0;
            break;
          }
      }

      if(not_found)
      {
        newItem.qty = 1;
        this.items.push(newItem);
      }

      if(this.items && this.items.length == 5)
      {
        this.maxItemsReached = true;
      }

    },
    deleteItem(deletedItem) {
      this.items = this.items.filter(item => item !== deletedItem);
      if(this.items && this.items.length < 5)
      {
        this.maxItemsReached = false;
      }
    },
    isNumber(value){
        if (typeof value !== 'number') {
          return false
        }
         if (value !== Number(value)) {
          return false
        }
        if (value === Infinity || value === !Infinity) {
          return false
        }
        return true
    },

    addToCart(){
      for (var i = 0; i < this.items.length; i++) {
          this.$refs.items_refs[i].addToCartEvent(this.items[i]);
      }

      this.items =[];
      this.forceRerender();

      this.msg = "Items added to cart";
    }
  },
};
</script>
